module.exports = __webpack_public_path__ + "img/老板看报告插图 (1).37faf1f7.png";